export const POPUP_SCROLL_FADE_THRESHOLD_PX = 1

export type PopupScrollMetrics = {
  scrollTop: number
  scrollHeight: number
  clientHeight: number
}

export type PopupScrollFades = {
  isTopGradientShown: boolean
  isBottomGradientShown: boolean
}

export const resolvePopupScrollFades = ({
  scrollTop,
  scrollHeight,
  clientHeight,
}: PopupScrollMetrics): PopupScrollFades => {
  const overflow = scrollHeight - clientHeight > POPUP_SCROLL_FADE_THRESHOLD_PX
  if (!overflow) {
    return { isTopGradientShown: false, isBottomGradientShown: false }
  }

  return {
    isTopGradientShown: scrollTop > POPUP_SCROLL_FADE_THRESHOLD_PX,
    isBottomGradientShown:
      scrollHeight - scrollTop - clientHeight > POPUP_SCROLL_FADE_THRESHOLD_PX,
  }
}
